module.exports = __webpack_public_path__ + "static/12-33ba2f51fc1594049a0040dcd54a82eb.jpg";